export default __webpack_public_path__ + "static/TC_Step_4-dcbd99220787d2fe475b0d62a36bf0b1.svg";